import { readSubscribed } from "../../../data/repository/scheduled.repository";

export const ReadSubscribedUseCase = async () => {
  try {
    const resp = await readSubscribed();
    return resp.data;
  } catch (error) {
    return error.response.data;
  }
};